export default __webpack_public_path__ + "static/media/promo-undesirable-no-1_00.593cf1a8.jpg";